namespace appn.views.taskTemplates.presets {
    class InitArgs {
        dataNamesUsed: Array<Array<string>> = [];
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;
        addEvents();
        setRowsOnPageLoad();
    }

    function addEvents() {
        $(document).on('click', '.fieldTable .delete_button', function() {
            const presetIdx = $(this)?.closest('.fieldTable')?.attr('id')?.replace('fields_', appn.emptyString) ?? 0;
            const dataname = $(this).data('name');

            // enable the selected element
            $(`#addField_${presetIdx} option[value='${dataname}']`).prop('disabled', false);

            const parentName = $(this).parents('tr').attr('parent') as string;
            $(this).parents('tr').remove();
            checkToRemoveParentRowIfEmpty(Number(presetIdx), parentName);

            if ($(`#fields_${presetIdx} tbody tr`).length > 0)
                reIndexRowItems((presetIdx as number));
            else {
                const span = elementBuilder.createElement('span', ['lead', 'text-gray'], undefined, undefined, T('Select which fields can be edited when dispatching the Task'));
                const div = elementBuilder.createElement('div', 'text-center');
                div.appendChild(span);
                const cell = elementBuilder.createElement('td', undefined, undefined, [['colspan', '4']]);
                cell.appendChild(div);
                const row = elementBuilder.createElement('tr', 'helperText');
                row.appendChild(cell);

                $(`#fields_${presetIdx} tbody`).append(row);
            }

            select.init();
        });

        $('.addField').on('change', function(this: HTMLElement, event: any) {
            event.preventDefault();
            $('.helperText').remove();
            if ($(this).val() === '0')
                return;

            const presetIdx = ($(this).attr('id') as string).replace('addField_', appn.emptyString);
            const dataName = $(this).val() as string;
            const type: elementBuilder.RowType = elementBuilder.RowType[$(this).find('option:checked').attr('row-type') as keyof typeof elementBuilder.RowType];

            const newRow = elementBuilder.getNewRow(this, dataName, false, presetIdx, type, _initArgs.dataNamesUsed);

            $(`#fields_${presetIdx} tbody`).append(newRow);

            // Disable the selected element
            $(`#addField_${presetIdx} option[value="${$(this).val()}"]`).prop('disabled', true);

            // Reset the selected index of the select list to the first index
            $(`#addField_${presetIdx}`).val('0');
            reIndexRowItems(Number(presetIdx));

            select.init();
        });
    }

    function setRowsOnPageLoad(): void {
        if (_initArgs.dataNamesUsed.length === 0)
            return;

        _initArgs.dataNamesUsed.forEach((preset: Array<string>) => {
            var presetIdx = Number(preset[0].split('|')[2]);

            var select = $(`select[id="addField_${presetIdx}"]`);
            $(`#fields_${presetIdx} tbody tr`).remove();

            preset.forEach((dataSet: string) => {
                const dataName = dataSet.split('|')[0];
                const dataValue = dataSet.split('|')[1].toBooleanExact();

                const option = $(`option[value="${dataName}"]`);
                $(`#fields_${presetIdx} tbody`).append(elementBuilder.getNewRow(select[0], dataName, dataValue, presetIdx.toString(), elementBuilder.RowType[option.attr('row-type') as keyof typeof elementBuilder.RowType], _initArgs.dataNamesUsed));

                // disable the selected element
                $(`#addField_${presetIdx} option[value="${dataName}"]`).prop('disabled', true);

            });

            // reset the selected index of the select list to the first index
            $(`#addField_${presetIdx}`).val('0');

            reIndexRowItems(presetIdx);

            appn.ui.checkboxForceOnChanged('.task-template-preset-required');
        });
    }

    function reOrganiseRowsToMaintainIndexes(presetIdx: number): void {
        const rowDataIndexes: Array<number> = [];
        $(`#fields_${presetIdx} tbody tr`).each(function(index: number, row: HTMLElement) {
            rowDataIndexes.push(Number($(row).attr('data-index')));
        });

        rowDataIndexes.sort((a, b) => a - b);
        const newTbody = document.createElement('tbody');

        rowDataIndexes.forEach(function(rowDataIndex: number) {
            $(`#fields_${presetIdx} tbody tr[data-index="${rowDataIndex}"]`).appendTo(newTbody);
        });

        $(`#fields_${presetIdx} tbody`).remove();
        $(`#fields_${presetIdx}`).append(newTbody);
    }

    function reIndexRowItems(presetIdx: number) {
        // Redo the physical indexing of the rows
        reOrganiseRowsToMaintainIndexes(presetIdx);

        // Rename all rows to keep continuous field index
        let rowIdx = 0;

        $(`#fields_${presetIdx} tbody tr`).each(function(index: number, row: HTMLElement) {
            if (this.className === 'preset-page-header')
                return;

            $(this).find('input').each(function(index, col) {
                let inputName = $(this).attr('name');
                let inputId = $(this).attr('id');
                const label = $(this).closest('.appn-checkbox').find('label');

                if (inputName?.lastIndexOf('.Index') !== -1)
                    $(this).attr('value', rowIdx);

                inputName = inputName?.replace(/\.Fields\[[0-9]+\]\./, `.Fields[${rowIdx}].`) ?? appn.emptyString;
                $(this).attr('name', inputName);

                if (inputId !== undefined) {
                    inputId = inputId?.replace(/__Fields_[0-9]+__/, `__Fields_${rowIdx}__`) ?? appn.emptyString;
                    $(this).attr('id', inputId);
                    if (label !== undefined)
                        label.attr('for', inputId);
                }
            });
            rowIdx++;
        });

        popover.init();
    }

    function checkToRemoveParentRowIfEmpty(presetIdx: number, parentName: string): void {
        const children = $(`#fields_${presetIdx} tbody tr[parent="${parentName}"]`);

        if (children.length === 0) {
            const grandParentName = $(`#fields_${presetIdx} tbody tr[id="${parentName}"]`).attr('parent') as string;
            $(`#fields_${presetIdx} tbody tr[id="${parentName}"]`).remove();

            if (grandParentName)
                checkToRemoveParentRowIfEmpty(presetIdx, grandParentName);
        }
    }
}

